import { render, staticRenderFns } from "./QueueCards.vue?vue&type=template&id=673dfce4&scoped=true"
import script from "./QueueCards.vue?vue&type=script&lang=js"
export * from "./QueueCards.vue?vue&type=script&lang=js"
import style0 from "./QueueCards.vue?vue&type=style&index=0&id=673dfce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673dfce4",
  null
  
)

export default component.exports